import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";

import { useSelector } from 'react-redux';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { TabMenu } from 'primereact/tabmenu';
import { AuthContext } from "../../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import CustomDropdown from '../../../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const Magacin = () => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const user = useSelector(state => state.user)
        const [selectedRowIdItem , setSelectedRowIdItem] = useState(null);
        const isSelected = (row) => String(getIdItem(row)) === String(selectedRowIdItem);
        
        const [typeOptions, setTypeOptions] = useState([])
        const [izabran, setIzabran] = useState(false)
        const [idItem, setIdItem] = useState(null)
        const [popuni, setPopuni] = useState(false)
        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
        const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdItem = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

         const [formData, setFormData] = useState({
            magacin: '',
            id_tip: null
        });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali magacin da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id,
                                firma_id: company.companyId,
                                user_id: user.userId
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/GetWarehouse", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                               
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka magacina!",
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormData({
        magacin: apiData[0].magacin || '',
        id_tip: apiData[0].id_tip || null
      });
};

   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  firma_id: company.companyId,
                                  user_id: user.userId
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/GetWarehouseAndTypes", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                                setTypeOptions(parsedData.TypesDB)
                                setTableData(parsedData.WarehouseDB)


                                 if (parsedData.WarehouseDB && parsedData.WarehouseDB.length > 0) {
                                                const columns = Object.keys(parsedData.WarehouseDB[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                const originalOrder = Object.keys(parsedData.WarehouseDB[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[formSubmitted])



const resetData = ()=> {
        setFormData({
        magacin: '',
        id_tip: null
        });
}
const handleDeleteFuncRelease = () => {
       
            confirmDialog({
            message: "Želite obrisati magacin?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {
 
  if (idItem) {
    setFormSubmitted(true)
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idItem,
            firma_id: company.companyId,
            user_id: user.userId
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/DeleteWarehouse", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešno pasiviziranje magacina!",
                life: 3000,
                });
                resetData()
                setIdItem(null)
                setFormSubmitted(false)
                setSelectedRowIdItem(null)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali magacin za brisanje!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  
              //DATA
                  const hasAnyValue = Object.values(formData).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formData
                        };

                  if(izabran && idItem){
                 if(hasAnyValue){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idItem),
                                firma_id: company.companyId,
                                user_id: user.userId,
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/UpdateWarehouse", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima magacina.' && data[0].message != 'Nedostaje id za UPDATE.' 
                                        && data[0].message != 'Zapis nije pronađen ili nije aktivan.' && data[0].message != 'Izmena nije moguća: postoji drugi aktivan magacin sa istim nazivom i tipom.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                return
                               }

                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka magacina!",
                                life: 3000,
                                });
                           
                                setFormSubmitted(false)
                                
                                setIdItem(null)
                                setSelectedRowIdItem(null)
                                setIzabran(false)
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke magacina!",
                        life: 3000,
                    });
                }
           
           
                } else {
                  if(hasAnyValue){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  firma_id: company.companyId,
                                  user_id: user.userId,
                                  formData: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/InsertWarehouse", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                  if(data) {
                                        if(data.message != 'Već postoji aktivan magacin sa istim nazivom i tipom.' && data.message != 'Uspešan unos magacina!'){
                                        toast.current.show({
                                        severity: "error",
                                        summary: "Error",
                                        detail: data.message,
                                        life: 3000,
                                        });
                                        return
                                        } 
                                  }
                                  
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka magacina!",
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke magacina za unos!",
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formData) {
        setFormData(prev => ({ ...prev, [name]: value }));
        }
    };
  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Magacini');
  
      const headers = selectedColumns;

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Magacin - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">              
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
              {selectedRowIdItem && <Button type="button" style={{marginLeft:'5px'}} icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncRelease} data-pr-tooltip="Print" />}             
              </div>
                                                             <input
                                                type="search"
                                                onInput={(e) => setGlobalFilter(e.target.value)}
                                                placeholder={t('nova.phPretraga')}
                                                className="p-inputtext p-component"
                                              />
          </div>
      );

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseItem = (rowData) => {
        const id = getIdItem(rowData);

        setSelectedRowIdItem((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdItem(next)
        popuniRedove(id)
        setIzabran(true) 
        }
        else {
        setIdItem(null)
        resetData()
        setIzabran(false) 
        }

        return next;
    });
    }

     const previewBodyTemplate = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseItem(rowData)}
              />
            
        </div>
      );
    };

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />        

        <ConfirmDialog />
            <div className='col-12 md:col-6'>
                          <div className='blagajnaDashboard dnevniceDashboard'>
                             <Card style={{minWidth:'50%'}}>
                            <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                            <div className="gridLicni">
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection  :'column'}}>
                                    <label htmlFor="magacin">{t('magacin.nazivMagacina')}:</label>
                                    <InputText
                                    id="magacin" 
                                    name="magacin" 
                                    value={formData.magacin} 
                                    required
                                    invalid={invalidControl(formData.magacin)}
                                    onChange={handleChange} 
                                    />
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_tip">{t('nova.tip')}:</label>
                                            <CustomDropdown
                                                 id="id_tip" 
                                                 name="id_tip" 
                                                 value={formData.id_tip} 
                                                 options={typeOptions || []}
                                                 placeholder={t('magacin.phTip')}
                                                 required
                                                invalid={invalidControl(formData.id_tip)}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                            </div>
                            <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", marginTop:'2%'}} className="btn btn-success">
                                {izabran ? "SAČUVAJ" : "UNOS"}
                            </button>
                            </div>
                            </form>
                          </Card>
                          <Card>
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                   <DataTable
                                          value={tableData || []}
                                          paginator
                                          rows={10}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight="50vh"
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={colMeta?.label || colKey}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplate(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                          </Card>
                          </div>
            </div>                                

       </div>
)
}

export default Magacin;